/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Accept_AllInputs */

const da_consent_accept_all = /** @type {(inputs: Consent_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptér alle`)
};

/** @type {(inputs: Consent_Accept_AllInputs) => LocalizedString} */
const en_consent_accept_all = da_consent_accept_all;

/**

* @param {Consent_Accept_AllInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_accept_all = /** @type {((inputs?: Consent_Accept_AllInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Accept_AllInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_accept_all(inputs)
	return /** @type {LocalizedString} */ ("Acceptér alle")
});